import styled from '@emotion/styled';
import { Box as MuiBox, Chip } from '@mui/material';

export const FormStyle = styled(MuiBox)`
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  height: calc(100vh - 130px);
`;

export const VehicleBarStyle = styled(MuiBox)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
  background: ${({ theme }) =>
    theme?.validateMode ? theme.validateMode({ light: '#F5F5F5', dark: '#2B2B2B' }) : '#F5F5F5'};
  border-radius: 0.25rem;
`;

export const VehicleIdWrap = styled(MuiBox)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DriverNameStyle = styled(MuiBox)`
  margin-left: auto;
  white-space: nowrap;
`;

export const TimePickerStyle = styled(MuiBox)`
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const RightWrap = styled(MuiBox)`
  width: -webkit-fill-available;

  [data-testid='trigger'] {
    width: -webkit-fill-available;
  }

  div.MuiStack-root {
    width: -webkit-fill-available;
    button:nth-child(2) {
      width: -webkit-fill-available;
    }
  }
`;

export const GridStyle = styled(MuiBox)`
  align-items: center;
  height: calc(100vh - 18rem);
`;

export const EmptyStateStyle = styled(MuiBox)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  height: calc(100vh - 18rem);
  text-align: center;
`;

// Active uses a filled light-blue chip (dark blue text, pale blue background).
const statusChipPalette = (theme, statusType) => {
  if (statusType === 'active') {
    return {
      color: theme?.validateMode
        ? theme?.validateMode?.({ light: '#1565C0', dark: theme?.colorsCA?.neutral?.[100] })
        : '#1565C0',
      background: theme?.validateMode ? theme?.validateMode?.({ light: '#E3F2FD', dark: '#14222F' }) : '#E3F2FD',
      border: 'none',
    };
  }

  if (statusType === 'pending') {
    const pendingColor = theme?.validateMode ? theme?.validateMode?.({ light: '#1976D2', dark: '#90CAF9' }) : '#1976D2';
    return { color: pendingColor, background: 'transparent', border: `1px solid ${pendingColor}` };
  }

  return {
    color: theme?.validateMode ? theme?.validateMode?.({ light: '#616161', dark: '#E0E0E0' }) : '#616161',
    background: 'transparent',
    border: `1px solid ${
      theme?.validateMode ? theme?.validateMode?.({ light: '#9E9E9E', dark: '#BDBDBD' }) : '#9E9E9E'
    }`,
  };
};

export const StatusChip = styled(Chip, {
  shouldForwardProp: prop => prop !== 'statusType',
})(({ theme, statusType }) => {
  const { color, background, border } = statusChipPalette(theme, statusType);

  return `
    font-weight: 500;
    border-radius: 0.5rem;
    min-width: 5.1875rem;
    border: ${border};
    color: ${color};
    background: ${background};
  `;
});

export const DetailRow = styled(MuiBox)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid
    ${({ theme }) => (theme?.validateMode ? theme.validateMode({ light: '#E0E0E0', dark: '#424242' }) : '#E0E0E0')};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const DetailLabel = styled(MuiBox)`
  color: ${({ theme }) =>
    theme?.validateMode ? theme.validateMode({ light: '#757575', dark: '#BDBDBD' }) : '#757575'};
`;

export const DetailValue = styled(MuiBox)`
  font-weight: 600;
  text-align: right;
`;

export const CreateTicketField = styled(MuiBox)`
  margin-bottom: 1rem;
`;
